export enum BillingsPlanEntryTaxiDriverRecalculateParamsContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  CHARGE_HIGHWAYS = "CHARGE_HIGHWAY",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
  BASE_AMOUNT_EXTERNAL_TAXI = "BASE_AMOUNT_EXTERNAL_TAXI",
  CONTRACT_CORRECTION_RATE = "CONTRACT_CORRECTION_RATE",
}

export type BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContributionBaseAmountExternalTaxi =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.BASE_AMOUNT_EXTERNAL_TAXI;
    distance: number;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContributionOtherRate =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.CONTRACT_CORRECTION_RATE;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateParamsBonusContributionFavorableDistance =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateParamsBonusContributionOther =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.BONUS_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionWrongRoute =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionBeingLate =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionIncompatibleCar =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionOther =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.PENALTY_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContribution =

    | BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContributionBaseAmountExternalTaxi
    | BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContributionOtherRate;

export type BillingsPlanEntryTaxiDriverRecalculateParamsBonusContribution =
  | BillingsPlanEntryTaxiDriverRecalculateParamsBonusContributionFavorableDistance
  | BillingsPlanEntryTaxiDriverRecalculateParamsBonusContributionOther;

export type BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContribution =
  | BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionWrongRoute
  | BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionBeingLate
  | BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionIncompatibleCar
  | BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionOther;

export type BillingsPlanEntryTaxiDriverRecalculateParamsContribution =
  | BillingsPlanEntryTaxiDriverRecalculateParamsBonusContribution
  | BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContribution
  | BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContribution;

export type BillingsPlanEntryTaxiDriverRecalculateParamsBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

type BillingsPlanEntryTaxiDriverRecalculateParams = {
  planEntryId: string;
  billingNodes: BillingsPlanEntryTaxiDriverRecalculateParamsBillingNode[];
  billingContributions: BillingsPlanEntryTaxiDriverRecalculateParamsContribution[];
};

export default BillingsPlanEntryTaxiDriverRecalculateParams;
